import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { SessionTimeoutWarning } from '../auth/SessionTimeoutWarning';

export function AppShell() {
  return (
    <div className="flex h-screen bg-cream dark:bg-midnight">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <Header />

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto">
          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Session timeout warning overlay */}
      <SessionTimeoutWarning />
    </div>
  );
}

// Export layout components for barrel exports
export { Sidebar } from './Sidebar';
export { Header } from './Header';
